import { Button, Intent } from '@blueprintjs/core'
import * as React from 'react'
import { Link } from 'react-router'

import queryString from 'query-string'
import Channels from '../../../../../constants/Channels'
import { ConnectedMarket, UniqueConnectedMarket } from '../../../../../current/types'
import { Channel } from '../types'
import { MarketAccountLite } from '../../../v2/types'
import { UprightStyle } from '../../../../../types'

const styles: UprightStyle = {
  center: { alignSelf: 'center' }
}

interface Props {
  channel: Channel | UniqueConnectedMarket
  connectedMarkets: ConnectedMarket[]
  supplier?: { marketAccounts: MarketAccountLite[] }
  productId: number
  openCreateListingWhichAccountDialog: (marketId: number, additionalQueryParams: {}) => void
  additionalQueryParams?: {}
}

const CreateListingButtonOrLink: React.FC<Props> = props => {
  const { channel, connectedMarkets, productId, supplier, openCreateListingWhichAccountDialog, additionalQueryParams } =
    props

  const queryParams: any = {
    market_id: channel.id,
    ...additionalQueryParams
  }

  let marketAccountId = null
  let needsMarketAccountIdParam = false

  // Channels that need marketAccountId for the "Create listing" step
  if ([Channels.EBAY.id].includes(channel.id)) {
    // Other channels don't need this and perform hacky manipulation of query params, see `this.props.location.search.replace`
    needsMarketAccountIdParam = true

    // Sometimes we know the appropriate ebay market_account_id, sometimes we don't.
    // If we know it, we can let the user navigate straight to the page to create a listing for _that account_
    // instead of showing a dialog for them to choose the account.
    if (supplier) {
      marketAccountId = supplier.marketAccounts.find(marketAccount => marketAccount.marketId === channel.id)?.id
    }

    if (!marketAccountId) {
      const ebayConnectedMarkets = connectedMarkets.filter(
        connectedMarket => connectedMarket.marketId === channel.id && connectedMarket.onboarded
      )

      if (ebayConnectedMarkets.length === 1) {
        // Orgs that only have 1 ebay account will always use this to list
        marketAccountId = ebayConnectedMarkets[0].marketAccountId
      }
    }

    if (marketAccountId) {
      queryParams.market_account_id = marketAccountId
    }
  }

  let buttonOrLink = null
  if (marketAccountId || !needsMarketAccountIdParam) {
    buttonOrLink = (
      <Link style={styles.center} to={`/products/${productId}/listings/new?${queryString.stringify(queryParams)}`}>
        <Button text="Create listing" minimal intent={Intent.PRIMARY} />
      </Link>
    )
  } else {
    buttonOrLink = (
      <Button
        text="Create listing"
        minimal
        intent={Intent.PRIMARY}
        onClick={() => {
          openCreateListingWhichAccountDialog(channel.id, queryParams)
        }}
      />
    )
  }

  return buttonOrLink
}

export default CreateListingButtonOrLink
